<div class="w-screen h-full flex flex-row justify-center m-0 p-0">
  <section class="max-w-screen-sm h-full py-8 px-10">
    <p>Formulario Preenchido !</p>
  </section>
</div>
